import styled, { css } from "styled-components";
import { BREAKPOINT, COLOR } from "../../components/theme";

const MAX_CONTENT_WIDTH = "350px";

export const CustomerOktaContainer = styled.div`
  margin: 0 auto;

  #okta-sign-in {
    position: relative !important;
    border: none !important;
    margin: 0 !important;
  }

  #okta-sign-in.auth-container.main-container {
    box-shadow: none !important;
  }

  #okta-sign-in .okta-sign-in-header {
    visibility: hidden;
  }

  #okta-sign-in .o-form-head {
    display: none !important;
  }

  #okta-sign-in .auth-content {
    padding: 0 !important;
    width: ${MAX_CONTENT_WIDTH} !important;
  }

  #okta-sign-in .auth-header {
    padding: 10px;
  }

  #okta-sign-in .mfa-verify {
    visibility: hidden;
  }

  @media only screen and (max-width: ${BREAKPOINT.SIZE_MOBILE}) {
    #okta-sign-in .auth-content {
      max-width: 100% !important;
    }
  }

  #okta-sign-in .auth-footer {
    display: none !important;
  }

  #okta-sign-in.main-container {
    background-color: transparent !important;
  }

  #okta-sign-in.auth-container .btn-disabled {
    font-family: 'LatitudeSans', sans-serif;
    font-size: 16px;
    font-weight: 600;
    background-color: ${COLOR.BUTTON.DISABLED};
    color: ${COLOR.GREY_INACTIVE};
    border: 1px solid ${COLOR.GREY_INACTIVE};
    cursor: not-allowed;
  }

  #okta-sign-in.auth-container input[type="text"],
  #okta-sign-in.auth-container input[type="password"] {
    background-color: rgb(242, 242, 242) !important;
    border-width: 0px !important;
    border: none !important;
    outline: 0 !important;
  }

  #okta-sign-in.auth-container input[type="text"]:hover,
  #okta-sign-in.auth-container input[type="password"]:hover {
    outline: none !important;
  }

  #okta-sign-in.auth-container input[type="text"]:focus,
  #okta-sign-in.auth-container input[type="password"]:focus {
    outline: none !important;
  }

  #okta-sign-in.auth-container
    .mfa-verify-passcode
    .okta-form-subtitle.o-form-explain::before {
    content: "Please enter the verification code that's been sent to your mobile number ";
  }

  #okta-sign-in.auth-container
    .mfa-verify-passcode
    .okta-form-subtitle.o-form-explain::after {
    content: ". Code expires in 15 minutes.";
  }

  #okta-sign-in.auth-container
    .button.sms-request-button[data-se="sms-send-code"] {
    background: ${COLOR.BUTTON.WHITE};
    color: ${COLOR.LATITUDE_BLUE_INDIGO};
    font-family: 'LatitudeSans', sans-serif;
    font-weight: 600;
    border: 1px solid ${COLOR.LATITUDE_BLUE_INDIGO};

    &:hover:not(.btn-disabled) {
      background: ${COLOR.LATITUDE_BLUE_INDIGO};
      color: rgb(255, 255, 255) !important;
      border: 1px solid ${COLOR.LATITUDE_BLUE_INDIGO};
    }

    &.btn-disabled {
      background: ${COLOR.BUTTON.DISABLED};
      color: ${COLOR.GREY_INACTIVE};
      border: 1px solid ${COLOR.GREY_INACTIVE};
      cursor: not-allowed;
    }
  }

  #okta-sign-in.auth-container .button-primary:hover:not(.btn-disabled) {
    background: ${COLOR.BUTTON.HOVER} !important;
    font-family: 'LatitudeSans', sans-serif;
    font-size: 16px;
    line-height: 28px;
    font-weight: 600;
    color: ${COLOR.LATITUDE_BLUE_INDIGO}
  }
   #okta-sign-in.auth-container .button-primary {
    background: ${COLOR.BUTTON.DEFAULT};
    font-family: 'LatitudeSans', sans-serif;
    font-size: 16px;
    line-height: 28px;
    font-weight: 600;
    border: none;
    color: ${COLOR.LATITUDE_BLUE_INDIGO};
    box-shadow: none;

    &.btn-disabled {
      background: ${COLOR.BUTTON.DISABLED} !important;
      color: ${COLOR.GREY_INACTIVE} !important;
      border: 1px solid ${COLOR.GREY_INACTIVE} !important;
      cursor: not-allowed;
    }
  }
  #okta-sign-in.auth-container .button-primary, 
  #okta-sign-in.auth-container .button-primary:active, 
  #okta-sign-in.auth-container .button-primary:focus {
    background: ${COLOR.BUTTON.DEFAULT} !important;
    font-family: 'LatitudeSans', sans-serif;
    font-size: 16px;
    line-height: 28px;
    font-weight: 600;
    color: ${COLOR.LATITUDE_BLUE_INDIGO}
  }

  #okta-sign-in .btn-secondary:not(.btn-disabled) {
    background-color: ${COLOR.WHITE} !important;
    color: ${COLOR.LATITUDE_BLUE_INDIGO} !important;
    border: 1px solid ${COLOR.LATITUDE_BLUE_INDIGO} !important;
    font-family: 'LatitudeSans', sans-serif;
    font-size: 16px;
    font-weight: 600;
  }

  #okta-sign-in .btn-secondary:hover:not(.btn-disabled) {
    background: ${COLOR.LATITUDE_BLUE_INDIGO} !important;
    color: rgb(255, 255, 255) !important;
    border: 1px solid ${COLOR.LATITUDE_BLUE_INDIGO} !important;
    color: ${COLOR.WHITE}
    font-family: 'LatitudeSans', sans-serif;
    font-size: 16px;
    font-weight: 600;
  }

  #okta-sign-in .auth-divider {
    background-color: transparent !important;
  }

  #okta-sign-in .auth-divider .auth-divider-text {
    text-transform: lowercase;
    font-weight: 600;
    color: ${COLOR.LATITUDE_BLUE_INDIGO};
    ${(props) =>
      props.color &&
      css`
        color: ${props.color || COLOR.LATITUDE_BLUE_INDIGO};
      `}
  }

  #okta-sign-in .o-form .o-form-label {
    color: ${COLOR.LATITUDE_BLUE_INDIGO};
     ${(props) =>
       props.color &&
       css`
         color: ${props.color || COLOR.LATITUDE_BLUE_INDIGO};
       `}
  }
    
  #okta-sign-in .o-form .custom-checkbox label {
    color: ${COLOR.LATITUDE_BLUE_INDIGO};
     ${(props) =>
       props.color &&
       css`
         color: ${props.color || COLOR.LATITUDE_BLUE_INDIGO};
       `}
  }
  
  #okta-sign-in .o-form .custom-checkbox.focused-input {
    box-shadow: none
  }

  #okta-sign-in.auth-container .o-form-explain {
      text-align: left;
      ${(props) =>
        props.color &&
        css`
          color: ${props.color || COLOR.LATITUDE_BLUE_INDIGO};
        `};
      ${(props) =>
        props.contentFontFamily &&
        css`
          font-family: ${props.contentFontFamily}, sans-serif;
        `}
  }

  #okta-sign-in.auth-container .mfa-send-email-content {
     color: ${COLOR.LATITUDE_BLUE_INDIGO};
      ${(props) =>
        props.color &&
        css`
          color: ${props.color || COLOR.LATITUDE_BLUE_INDIGO};
        `};
      ${(props) =>
        props.contentFontFamily &&
        css`
          font-family: ${props.contentFontFamily}, sans-serif;
        `}
  }
`;
